<div class="provider-section-grid provider-address-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">{{ showReviewStatus ? 'Personal Address' : 'Provider Details' }}</h5>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalAddress1" class="field-label">Street Address</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalAddress1"
          matInput
          type="text"
          placeholder="123 Main Street"
          class="user-record-field-input"
          formControlName="personalAddress1" />
        @if (formGroup.get('personalAddress1')?.invalid && formGroup.get('personalAddress1')?.touched) {
          <mat-error>Street Address is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalAddress2" class="field-label">Street Address 2 (Optional)</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalAddress2"
          matInput
          type="text"
          placeholder="Apt, Suite, etc."
          class="user-record-field-input"
          formControlName="personalAddress2" />
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="personalCity" class="field-label">City</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalCity"
          matInput
          type="text"
          placeholder="City"
          class="user-record-field-input"
          formControlName="personalCity" />
        @if (formGroup.get('personalCity')?.invalid && formGroup.get('personalCity')?.touched) {
          <mat-error>City is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalState" class="field-label">State</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalState"
          matInput
          type="text"
          placeholder="State"
          class="user-record-field-input"
          formControlName="personalState"
          [matAutocomplete]="stateAuto" />
        <mat-autocomplete #stateAuto="matAutocomplete" [displayWith]="displayStateName">
          @for (state of filteredStates | async; track state) {
            <mat-option [value]="state">{{ state.name }}</mat-option>
          }
        </mat-autocomplete>
        @if (formGroup.get('personalState')?.invalid && formGroup.get('personalState')?.touched) {
          <mat-error>State is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalZip" class="field-label">Zip Code</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalZip"
          matInput
          type="text"
          maxlength="5"
          placeholder="12345"
          class="user-record-field-input"
          formControlName="personalZip"
          [attr.aria-describedby]="formGroup.get('personalZip')?.invalid && formGroup.get('personalZip')?.touched ? 'personalZip-error' : null" />
        @if (formGroup.get('personalZip')?.invalid && formGroup.get('personalZip')?.touched) {
          @if (formGroup.get('personalZip')?.hasError('required')) {
            <mat-error id="personalZip-error">Zip Code is required</mat-error>
          } @else if (formGroup.get('personalZip')?.hasError('invalidZipCode')) {
            <mat-error id="personalZip-error">Zip Code must be 5 digits</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  @if (isPersonalNorthCarolina()) {
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="tutorPersonalCounty" class="field-label">County</label>
        <mat-form-field class="provider-fields">
          <input
            id="tutorPersonalCounty"
            matInput
            type="text"
            placeholder="County"
            class="user-record-field-input"
            formControlName="personalCounty"
            [matAutocomplete]="countyAutoTutor" />
          <mat-autocomplete #countyAutoTutor="matAutocomplete">
            @for (county of filteredCounties | async; track county.name) {
              <mat-option [value]="county.name">{{ county.name }}</mat-option>
            }
          </mat-autocomplete>
          @if (formGroup.get('personalCounty')?.invalid && formGroup.get('personalCounty')?.touched) {
            <mat-error>County is required</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="tutorPhone" class="field-label">Phone Number</label>
      <mat-form-field class="provider-fields">
        <input
          id="tutorPhone"
          matInput
          type="text"
          placeholder="(123) 456-7890"
          [mask]="'(000) 000-0000'"
          formControlName="phone"
          class="user-record-field-input"
          [dropSpecialCharacters]="false"
          [attr.aria-describedby]="formGroup.get('phone')?.invalid && formGroup.get('phone')?.touched ? 'tutorPhone-error' : null" />
        @if (formGroup.get('phone')?.invalid && formGroup.get('phone')?.touched) {
          @if (formGroup.get('phone')?.hasError('required')) {
            <mat-error id="tutorPhone-error">Phone number is required</mat-error>
          } @else if (formGroup.get('phone')?.hasError('invalidPhone')) {
            <mat-error id="tutorPhone-error">Phone number must be a valid US phone number</mat-error>
          } @else {
            <mat-error id="tutorPhone-error">Phone number is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="tutorSecondaryPhone" class="field-label">Secondary Phone Number</label>
      <mat-form-field class="provider-fields">
        <input
          id="tutorSecondaryPhone"
          matInput
          type="text"
          placeholder="(123) 456-7890"
          [mask]="'(000) 000-0000'"
          formControlName="secondaryPhone"
          class="user-record-field-input"
          [dropSpecialCharacters]="false" />
        @if (formGroup.get('secondaryPhone')?.invalid && formGroup.get('secondaryPhone')?.touched) {
          @if (formGroup.get('secondaryPhone')?.hasError('invalidPhone')) {
            <mat-error>Phone number must be a valid US phone number</mat-error>
          } @else {
            <mat-error>Phone number is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="tutorBirthDate" class="field-label">Date of Birth</label>
      <mat-form-field class="provider-fields">
        <input
          id="tutorBirthDate"
          matInput
          [matDatepicker]="birthDatePicker"
          (click)="birthDatePicker.open()"
          placeholder="MM/DD/YYYY"
          class="user-record-field-input"
          formControlName="birthDate" />
        <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #birthDatePicker startView="multi-year"></mat-datepicker>
        @if (formGroup.get('birthDate')?.invalid && formGroup.get('birthDate')?.touched) {
          @if (formGroup.get('birthDate')?.hasError('required')) {
            <mat-error>Date of Birth is required</mat-error>
          } @else if (formGroup.get('birthDate')?.hasError('futureDate')) {
            <mat-error>Date of Birth must be in the past</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="socialSecurityLast4" class="field-label">Last 4 of SSN</label>
      <mat-form-field class="provider-fields">
        <input
          id="socialSecurityLast4"
          matInput
          type="text"
          placeholder="1234"
          class="user-record-field-input"
          formControlName="socialSecurityLast4"
          [attr.aria-describedby]="formGroup.get('socialSecurityLast4')?.invalid && formGroup.get('socialSecurityLast4')?.touched ? 'socialSecurityLast4-error' : null" />
        @if (formGroup.get('socialSecurityLast4')?.invalid && formGroup.get('socialSecurityLast4')?.touched) {
          @if (formGroup.get('socialSecurityLast4')?.hasError('required')) {
            <mat-error id="socialSecurityLast4-error">Last 4 of SSN is required</mat-error>
          } @else if (formGroup.get('socialSecurityLast4')?.hasError('invalidSSN')) {
            <mat-error id="socialSecurityLast4-error">Last 4 of SSN format is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="schoolName" class="field-label">School Name</label>
      <mat-form-field class="provider-fields">
        <input
          id="schoolName"
          matInput
          type="text"
          placeholder="School Name"
          class="user-record-field-input"
          formControlName="schoolName"
          [matAutocomplete]="schoolAuto" />
        <mat-autocomplete #schoolAuto="matAutocomplete" (optionSelected)="onSchoolSelected($event)">
          @for (school of filteredSchoolOptions | async; track school.id) {
            <mat-option [value]="school">{{ formatSchoolLabel(school) }}</mat-option>
          }
        </mat-autocomplete>
        @if (formGroup.get('schoolName')?.invalid && formGroup.get('schoolName')?.touched) {
          <mat-error>School Name is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="graduationDate" class="field-label">Graduation Date</label>
      <mat-form-field class="provider-fields">
        <input
          id="graduationDate"
          matInput
          [matDatepicker]="graduationDatePicker"
          (click)="graduationDatePicker.open()"
          placeholder="Graduation Date"
          class="user-record-field-input"
          formControlName="graduationDate" />
        <mat-datepicker-toggle matIconSuffix [for]="graduationDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #graduationDatePicker></mat-datepicker>
        @if (formGroup.get('graduationDate')?.invalid && formGroup.get('graduationDate')?.touched) {
          <mat-error>Graduation Date is required</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</div>
